import ScrollMagic from 'scrollmagic';
import TimelineMax from 'TimelineMax';
import 'animation.gsap';
import 'debug.addIndicators';

$(function () {

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    Content Section Scroll Animation

    */
    const $animationElements = $('.scroll-animation');
    const isMobile = $(window).width() < 768;

    // $animationElements.forEach(function(element) {})
    $.each($animationElements, function(i, val) {
        const $element = $(val);
        initScrollAnimation1($element);
    })

    function initScrollAnimation1(rootElement) {
        const controller = new ScrollMagic.Controller({
            // addIndicators: true
        });

        // Setup GSAP Timeline
        const tl = new TimelineMax({});

        // animate borders
        const $animationFrame = rootElement.children('.content-section__scroll-animation-frame');
        tl.to($animationFrame, 1, {
            css: {
                borderWidth: 0,
            },
        });

        // animate overlay
        const $animationOverlay = rootElement.children('.content-section__outer-overlay');
        tl.to($animationOverlay, 5, {
            css: {
                opacity: 1,
            },
            delay: 5,
        });

        // animate contents
        const $animationContent = rootElement.children('.content-section__main-col-container');
        const $animationContentCol = $animationContent.find('.content-section__col');
        const isMobileAndLongContent = isMobile && $animationContentCol.height() > $(window).height();
        tl.to($animationContent, 20, {
            css: {
                transform: isMobileAndLongContent ? 'translateY(-180%)' : 'translateY(-100%)',
            },
            // delay: 1,
        });

        // create a scene
        new ScrollMagic.Scene({
            triggerElement: rootElement.get(0),
            duration: '100%', // the scene should last for a scroll distance of rootElement's height
            triggerHook: 0,
            offset: 0 // start this scene after scrolling for 0px
        })
        .setTween(tl)
        // .addIndicators({
        //     name: 'content-section'
        // })
        .setPin(rootElement.get(0), {pushFollowers: true}) // pins the element for the the scene's duration
        .addTo(controller); // assign the scene to the controller


    }



});



// WEBPACK FOOTER //
// ./static/js/modules/content-section.js